import {DiscountData} from "@/types/discounts";
import { DiscountState } from "@/types/store/adminzone/discounts";

export const state: DiscountState = {
  discounts: [] as Array<DiscountData>,
  discountsTotalCount: null
}
